import FilterParamsUtil from '../../sections/collection-grid/filter-params-util'


const CollectionFilterSpColors = (el, onClose) => {


  let filterParams = []


  const initialize = () => {
    el.querySelector('.fs-back-button').addEventListener('click', () => {
      el.classList.remove('show')
      onClose(false, null)
    })
    el.querySelector('.fs-close-button').addEventListener('click', () => {
      el.classList.remove('show')
      onClose(true, null)
    })
    el.querySelector('.fs-clear-button').addEventListener('click', () => {
      const newFilterParams = filterParams.filter(kv => kv.key != 'meta.custom.search_color')
      handleChangeFilterParams(newFilterParams)
    })
    el.querySelector('.fs-select-button').addEventListener('click', () => {
      el.classList.remove('show')
      onClose(false, filterParams)
    })
    el.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', e => {
        if (e.target.checked) {
          handleChangeFilterParams([...filterParams, {key: e.target.name, value: e.target.value}])
          return
        }
        const newFilterParams = filterParams.filter(kv => kv.key != e.target.name || kv.value != e.target.value)
        handleChangeFilterParams(newFilterParams)
      })
    })
  }


  const show = (newFilterParams) => {
    filterParams = FilterParamsUtil.duplicate(newFilterParams)
    handleChangeFilterParams(newFilterParams)
    el.classList.add('show')
  }


  const handleChangeFilterParams = (newFilterParams) => {
    if (filterParams == newFilterParams) {
      return
    }
    el.querySelectorAll('input').forEach(input => {
      input.checked = false
      if (0 <= newFilterParams?.findIndex(kv => kv.key == input.name && kv.value == input.value)) {
        input.checked = true
      }
    })
    filterParams = newFilterParams
  }


  initialize()

  return {
    show: show
  }
}


export default CollectionFilterSpColors
